"use client";
import React from "react";
import {Box, Chip} from "@mui/material";
import {useTheme} from "@mui/material/styles";
import {SelectedChipsProps} from "@/app/(pages)/(general)/(home)/components/filter/types/filter";


export default function SelectedChips({values, setFieldValue, dialog}: SelectedChipsProps) {
    const theme = useTheme();

    const combinedOptions = [
        ...values.Car.map((item, index) => ({
            ...item,
            category: "خودرو:",
            isFirst: index === 0,
        })),
        ...values.Company.map((item, index) => ({
            ...item,
            category: "برند:",
            isFirst: index === 0,
        })),
        ...values.Section.map((item, index) => ({
            ...item,
            category: "بخش:",
            isFirst: index === 0,
        })),
    ];

    return (
        <Box position = "relative" >
            <Box
                position = "absolute"
                bottom = {0}
                left = {0}
                right = {0}
                height = {20}
                zIndex = {10}
                bgcolor = {`linear-gradient(to top, ${theme.palette.background.paper}, ${theme.palette.background.paper}00)`}
                sx = {{
                    pointerEvents: "none",
                }}
            />
            <Box
                display = "flex"
                mt = {{md: 2, xs: 3}}
                width = "100%"
                flexWrap = "wrap"
                alignItems = "center"
                alignContent = "start"
                // alignContent = {dialog ? "start" : "auto"}
                gap = {dialog ? 1.2 : 1.2}
                overflow = "auto"
                height = {{md: dialog ? 164 : 80, xs: 90}}
            >
                {combinedOptions.map((option, index, array) => {
                    const isFirstOccurrence = index === 0 || array[index - 1].category !== option.category;

                    return (
                        <React.Fragment key = {`${option.value}-${option.category}`} >
                            {isFirstOccurrence && (
                                <Chip
                                    label = {option.category}
                                    variant = "filled"
                                    sx = {{
                                        fontWeight: "bold",
                                        color: theme.palette.primary.main,
                                        bgcolor: theme.palette.grey[100],
                                    }}
                                />
                            )}

                            <Chip
                                label = {option.label}
                                variant = "outlined"
                                sx = {{
                                    borderRadius: 4,
                                    color: theme.palette.primary.main,
                                    border: `1px solid ${theme.palette.grey[300]}`,
                                    "& .MuiChip-deleteIcon": {
                                        color: theme.palette.primary.button,
                                        "&:hover": {
                                            color: theme.palette.error.main,
                                        },
                                    },
                                }}
                                onDelete = {() => {
                                    if (option.category === "خودرو:") {
                                        setFieldValue(
                                            "Car",
                                            values.Car.filter((item) => item?.value !== option.value)
                                        );
                                    } else if (option.category === "برند:") {
                                        setFieldValue(
                                            "Company",
                                            values.Company.filter((item) => item?.value !== option.value)
                                        );
                                    } else if (option.category === "بخش:") {
                                        setFieldValue(
                                            "Section",
                                            values.Section.filter((item) => item?.value !== option.value)
                                        );
                                    }
                                }}
                            />
                        </React.Fragment >
                    );
                })}
            </Box >
        </Box >
    );
}
